<template>
  <div class="concernContainer">
    <div class="header">
      <img src="../../../assets/Uram/manuscript/articleLogo_02.png" alt="">
      <div class="bodyTitle testClass">重要稿件列表</div>
      <el-button-group class="showDate">
        <el-button
          type="primary"
          class=""
          @click.stop="getDate"
        >日</el-button>
        <el-button type="primary" @click.stop="getDate">周</el-button>
        <el-button type="primary" @click.stop="getDate">月</el-button>
      </el-button-group>
    </div>
    <!-- <div class="bj"> -->
    <div data-v-4a6bcdc8 class="main">
      <div data-v-4a6bcdc8 id="tab1" class="main_list">
        <ul data-v-4a6bcdc8 class="list list_item_animate">
          <li data-v-4a6bcdc8 class="list_title list_title_animate">
            <ul data-v-4a6bcdc8>
              <li data-v-4a6bcdc8 class="list_title_item">序号</li>
              <li data-v-4a6bcdc8 class="list_title_item">标题</li>
              <li data-v-4a6bcdc8 class="list_title_item">点击数</li>
              <li data-v-4a6bcdc8 class="list_title_item">转载媒体数</li>
              <li data-v-4a6bcdc8 class="list_title_item">来源</li>
            </ul>
          </li>
          <li
            data-v-4a6bcdc8
            id="list"
            class="list_item animated"
            v-for="(item,index) in options"
            :key="index"
            :class="index == activeIndex ? 'active' : ''"
          >
            <div data-v-4a6bcdc8 class="counts1">
              <div v-if="index == 0" class="container first">{{ index + 1 }}</div>
              <div v-if="index == 1" class="container second">{{ index + 1 }}</div>
              <div v-if="index == 2" class="container third">{{ index + 1 }}</div>
              <div v-if="index != 0 && index != 1 && index != 2" class="container">{{ index + 1 }}</div>
            </div>
            <div data-v-4a6bcdc8 class="counts2">{{item.title}}</div>
            <div data-v-4a6bcdc8 class="counts3">{{item.readCount}}</div>
            <div data-v-4a6bcdc8 class="counts4">{{item.mediaCount}}</div>
            <div data-v-4a6bcdc8 class="counts5">{{item.name}}</div>
          </li>
        </ul>
      </div>
    </div>
    <!-- </div> -->
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      options: [],
      activeIndex: 0,
      interval: "",
      today: "",
      nowDay: "",
      showBody: "",
      show: false,
      userId: "",
      id: "",
      queryId: "",
      s_id: "",
      NUM: 0,
      set: null,
      out: null,
      date: "",
    };
  },
  created() {
  },
  mounted() {
    // this.scrolladd("tab1");
    this.getList("day")
  },
  methods: {
    getDate(e) {
      for (
        let i = 0;
        i < e.target.parentElement.parentElement.children.length;
        i++
      ) {
        e.target.parentElement.parentElement.children[i].className =
          "el-button el-button--primary";
      }
      if (e.target.innerText == "日") {
        this.date = "day";
        e.target.parentElement.className =
          "el-button el-button--primary dataSelect";
      } else if (e.target.innerText == "周") {
        this.date = "week";
        e.target.parentElement.className =
          "el-button el-button--primary dataSelect";
      } else {
        this.date = "month";
        e.target.parentElement.className =
          "el-button el-button--primary dataSelect";
      }
      this.getList();
    },
    getList(date) {
      if (date == "day") {
        var time = date;
      } else {
        time = this.date;
      }
      this.$http
        // .get(
        //   `${this.BASE_URL.url}lsg/agent_keyword/list.jspx?scid=${this.s_id}&userId=${sessionStorage.user}&id=${this.queryId}`
        // )
        .get(
          `http://lsgcloud.com/wlmq/screen/wlmq_manuscript/get.jspx?userId=${sessionStorage.user}&screenId=111&timeType=${time}`
        )
        .then((res) => {
          this.activeIndex = 0;
          this.options = res.data.data.items.map((k) => {
            return {
              title: k.title,
              readCount: k.readCount,
              mediaCount: k.mediaCount,
              reference: k.reference,
              name:k.name
            };
          });
        });
      // this.scrolladd("tab1");
    },
    scrolladd(id) {
      var len = $("#" + id).find(".list_item").length;
      console.log(len);
      var num = 0,
        addnum = 1;
      $("#" + id)
        .find(".list_item")
        .removeClass("listshow")
        // .removeClass("ggt");
      clearInterval(this.set);
      clearTimeout(this.out);
      addnum++;
      var self = this;
      this.set = setInterval(function () {
        if (num >= len) {
          clearInterval(this.set);
          self.addc(id, len);
        } else {
          $("#" + id)
            .find("dd")
            .eq(num)
            .addClass("listshow");
        }
        num++;
      }, 400);
    },
    addc(id, len) {
      var that = this;
      // console.log(this.NUM);
      $("#" + id)
        .find(".list_item")
        .eq(this.NUM)
        .addClass("ggt")
        .siblings()
        .removeClass("ggt");
      if (this.NUM > len - 1) {
        $("#" + id)
          .find(".list_item")
          .removeClass("ggt");
        clearTimeout(this.out);
      } else {
        this.out = null;
        this.out = setTimeout(function () {
          that.addc(id, len);
        }, 2000);
      }
      this.NUM++;
    },
  },
};
</script>

<style lang="scss">
.concernContainer {
  background-image: url("../../../assets/Uram/manuscript/expert_bg_img.jpg");
  background-size: 100% 100%;
  position: relative;
  height: 100%;
  .header {
    box-sizing: border-box;
    padding: 3vh 3.65% 2vh 8.2%;
    display: flex;
    .bodyTitle {
      color: #fff;
      font-size: 2rem;
      margin-top: 1.7vh;
      font-weight: bold;
    }
    .el-select {
      top: -5px;
      margin-left: 15px;
      width: 136px;
      .el-input--suffix {
        .el-input__inner {
          line-height: 33px;
          height: 33px;
          border-color: #008191;
          background-color: inherit;
          color: #02f6fe;
        }
      }
    }
    .showDate {
      font-size: 0.8rem;
      .el-button {
        width: 34px;
        height: 20px;
        padding: 0;
        left: 68vw;
        top: 4vh;
        border-color: #134fac;
        border-radius: 0;
        background-color: #03122a;
        color: #134fac;
        font-size: 12px;
        span {
          display: block;
          width: 34px;
          height: 20px;
          line-height: 20px;
        }
      }
      .dataSelect {
        background-color: #0e4293;
        color: #bfbfbf;
      }
    }
  }
  .main {
    box-sizing: border-box;
    width: 100%;
    // height: calc(100% - 1.9vh - 7.4vh - 0.1%);
    padding: 5.2vh 2.3% 6.4vh 2.3%;
    background-image: url("../../../assets/Uram/manuscript/qwtj.png");
    background-size: 95% 91%;
    background-repeat: no-repeat;
    background-position: center 3vh;
    .main_list {
      width: calc(100% - 5vw);
      height: calc(100% - 10vh);
      margin: 0 auto;
      //整体
      @keyframes fz {
        0% {
          opacity: 0;
          transform: translate(0, 0);
        }
        100% {
          opacity: 1;
          transform: translate(150px, 50px);
        }
      }
      .list {
        font-size: 1.8vw;
        color: white;
        .list_title {
          width: 100%;
          height: 2.3vh;
          line-height: 2.3vh;
          margin-bottom: 1.7vh;
          transition: all 0.4s;
          -webkit-transition: all 0.4s;
          transform: translate(150px, 100px);
          opacity: 0;
          .list_title_item {
            display: inline-block;
            text-align: center;
          }
          .list_title_item:first-child {
            width: 5.1%;
          }
          .list_title_item:nth-child(2) {
            width: calc(100% - 5.1% - 11vw - 26.2vw - 3.5vw - 2.7vw);
            text-align: center;
          }
          .list_title_item:nth-child(3) {
            width: 18vw;
            // margin-left: 0.7vw;
          }
          .list_title_item:nth-child(4),
          .list_title_item:nth-child(5) {
            width: 10.3vw;
            margin-left: 0.7vw;
          }
        }
        .list_title:first-child {
          font-size: 1vw;
        }
        .active:before {
          position: absolute;
          content: "";
          top: -4.8vh;
          left: -15%;
          width: 5%;
          height: 100%;
          background: url("../../../assets/Uram/manuscript/gt.png") no-repeat center
            center;
          background-size: 100% 100%;
          animation: gts 2s ease-in-out;
          background-image: linear-gradient(
            to right,
            rgba(0, 200, 255, 0.8),
            rgba(145, 165, 185, 0.8)
          );
          transform: translate(150px, 50px);
          transition: all 0.5s;
          -webkit-transition: all 0.5s;
          overflow: hidden;
        }
        @keyframes gts {
          0% {
            left: -14%;
          }
          100% {
            left: 93%;
          }
        }
        @-webkit-keyframes gts {
          0% {
            left: -14%;
          }
          100% {
            left: 93%;
          }
        }
        @keyframes layer {
          0% {
            opacity: 0;
            transform: scale(0, 0);
          }
          100% {
            opacity: 1;
            transform: scale(1, 1);
          }
        }
        .list_item {
          width: 100%;
          height: 8vh;
          line-height: 8vh;
          overflow: hidden;
          margin-bottom: 1.5vh;
          background-image: -webkit-linear-gradient(
            to right,
            rgba(0, 200, 255, 0.4),
            rgba(145, 165, 185, 0.4)
          );
          display: flex;
          border-radius: 8px;
          position: relative;
          transition: all 0.4s;
          transform: translate(150px, 100px);
          opacity: 0;
          div {
            text-align: center;
          }
          div::nth-child(n) {
            height: 100%;
          }
          .counts1 {
            width: 5.1%;
            font-style: italic;
            /*font-size: 1.65vw;*/
          }
          .counts2 {
            width: calc(100% - 5.1% - 11vw - 26.2vw - 3.5vw - 2.7vw);
            text-align: left;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
          div:nth-child(3) {
            width: 18vw;
            margin-left: 0.7vw;
          }
          div:nth-child(4),
          div:nth-child(5) {
            width: 10.3vw;
            margin-left: 0.7vw;
          }
        }
        .list_title_animate {
          transform: translate(0, 0);
          opacity: 1;
        }
        .list_item:nth-child(2),
        .list_item:nth-child(3),
        .list_item:nth-child(4) {
          background-image: -webkit-linear-gradient(
            to right,
            rgba(250, 5, 60, 0.4),
            rgba(110, 100, 120, 0.4)
          );
        }
        .ggt {
          background-image: -webkit-linear-gradient(
            to right,
            rgba(0, 200, 255, 1),
            rgba(145, 165, 185, 1)
          );
          background-image: linear-gradient(
            to right,
            rgba(0, 200, 255, 1),
            rgba(145, 165, 185, 1)
          );
        }

        .active {
          .counts2 {
            img {
              animation: flipOutX 1s;
            }
          }
          // transform: translate(150px, 50px);
          // -webkit-transform: translate(150px, 50px);
          background-image: -webkit-linear-gradient(
            to right,
            rgba(0, 200, 255, 1),
            rgba(145, 165, 185, 1)
          );
          overflow: hidden;
          position: relative;
        }
        // .active:nth-child(2),
        // .active:nth-child(3),
        // .active:nth-child(4) {
        //   background-image: -webkit-linear-gradient(
        //     left,
        //     rgba(250, 5, 60, 1),
        //     rgba(110, 100, 120, 1)
        //   );
        // }
        .activeall {
          // -webkit-transform: translate(150px, 50px);
          transition: opacity left 1s linear;
        }
      }
      .list_item_animate {
        .list_item {
          transform: translate(0, 0);
          opacity: 1;
          height: 3.1rem;
          line-height: 3.1rem;
          font-size: 1.67vw;
        }
        .list_item:nth-of-type(3) {
          transition-delay: 0.4s;
        }
        .list_item:nth-of-type(4) {
          transition-delay: 0.8s;
        }
        .list_item:nth-of-type(5) {
          transition-delay: 1.2s;
        }
        .list_item:nth-of-type(6) {
          transition-delay: 1.6s;
        }
        .list_item:nth-of-type(7) {
          transition-delay: 2s;
        }
        .list_item:nth-of-type(8) {
          transition-delay: 2.4s;
        }
        .list_item:nth-of-type(9) {
          transition-delay: 2.8s;
        }
        .list_item:nth-of-type(10) {
          transition-delay: 3.2s;
        }
        .list_item:nth-of-type(11) {
          transition-delay: 3.6s;
        }
      }
    }
  }
}
</style>
